export default "__VITE_ASSET__CBkZqZxs__"